export function postosplanejamentoInRequest(params = {}) {
  return {
    type: '@postoplanejamento/j',
    payload: { params },
  };
}

export function findPostoPlanejamento(idpostoplanejamento) {
  return {
    type: '@postoplanejamento/FIND_POSTOPLANEJAMENTO',
    payload: { idpostoplanejamento },
  };
}

export function failedRequest() {
  return {
    type: '@postoplanejamento/FAILED_REQUEST',
  };
}

export function deletePostoPlanejamento(idpostoplanejamento, params) {
  return {
    type: '@postoplanejamento/DELETE_FIND_POSTOPLANEJAMENTO',
    payload: { idpostoplanejamento, params },
  };
}

export function updatePostoPlanejamento(postoplanejamento, params) {
  return {
    type: '@postoplanejamento/UPDATE_POSTOPLANEJAMENTO',
    payload: { postoplanejamento, params },
  };
}

export function storePlanoPlanejamento(postoplanejamento, params) {
  return {
    type: '@postoplanejamento/STORE_POSTOPLANEJAMENTO',
    payload: { postoplanejamento, params },
  };
}

export function successInRequest(
  postosplanejamento,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@postoplanejamento/SUCCESS_IN_REQUEST',
    payload: { postosplanejamento, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(postoplanejamento) {
  return {
    type: '@postoplanejamento/SUCCESS_REQUEST',
    payload: { postoplanejamento },
  };
}

export function successRemove(params) {
  return {
    type: '@postoplanejamento/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@postoplanejamento/RECORD_FILTERING',
    payload: { params },
  };
}
